import axios from "@axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchUMDevices(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get("/um-devices", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchUMDevice(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/um-devices/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    addUMDevice(ctx, model) {
      return new Promise((resolve, reject) => {
        axios
          .post("/um-devices", model)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateUMDevice(ctx, model) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/um-devices/${model.id}`, model)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteUMDevice(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/um-devices/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    exportUMDevice(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get("/um-devices/export", { params: { id } })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
